import toast from "react-hot-toast"
import { useTranslation } from "react-i18next"

export const ElegirSala = ({ status, setSala }) => {
  // users, salas

  const is_admin = (id, rid) => {
    try {
      return status.rooms.find((r) => r.id === rid).admin === id
    } catch (error) {
      debugger
      const x = status.rooms.find((r) => r.id === rid)
      return x.admin === id
    }
  }

  const name = (id, rid) =>
    status.players.find((u) => u.id === id).nick +
    (is_admin(id, rid) ? " 👑" : "")

  const { t } = useTranslation()

  const try_enter_sala = (sala) => {
    sala.blocked ? toast.error(t(`games.tutti.err_locked`)) : setSala(sala.id)
  }

  return (
    <>
      <div className="title pt-4">{t(`games.sea_animals.select_a_room`)}</div>
      <div id="category-container" className="container-sm container-mini">
        <div className="d-flex flex-row flex-wrap justify-content-center">
          {/* usuarios online */}
          <div className="col-lg-4 col-12">
            <h6>
              {t("games.sea_animals.online", { count: status.players.length })}
            </h6>
            {status.players.map((u, uix) => (
              <div key={uix} className="row">
                &bull;&nbsp;{u.nick}
              </div>
            ))}
          </div>

          {/* salas */}
          <div className="col-lg-8 col-12">
            <div className="d-flex flex-column flex-wrap justify-content-center">
              {/* existentes */}
              {status.rooms.map((sala, six) => (
                <div key={six} className="col-lg-12 col-6 py-1">
                  <div
                    className="box category"
                    onClick={() => try_enter_sala(sala)}
                  >
                    <span style={{ margin: "8px 0 0 0" }}>
                      {t("games.sea_animals.room")} <b>{six + 1}</b>
                    </span>
                    <div>
                      <center>
                        <span className="block_status">
                          {sala.blocked
                            ? t(`games.tutti.closed_room`)
                            : t(`games.tutti.open_room`)}
                        </span>

                        {sala.players
                          .map((id, uix) => name(id, sala.id))
                          .join(", ")}
                      </center>
                    </div>
                  </div>
                </div>
              ))}

              {/* crear nueva */}
              <div className="col-lg-12 col-6 py-1">
                <div
                  style={{ height: "100%" }}
                  className="box category"
                  onClick={() => setSala(-1)}
                >
                  <span className="block_status">
                    {t(`games.tutti.open_room`)}
                  </span>
                  <span>{t("games.sea_animals.empty_room")}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
